<template>
  <div
    class="modal fade createNewModal"
    id="AddModalTypeCargaison"
    tabindex="-1"
    ref="addTypeCargaisonModalRef"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="typeCargaisonForm" @submit="addTypeCargaison" :validation-schema="typeCargaisonSchema">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Libellé  <span class="text-danger">*</span>
                  </label>
                  <Field name="libelle" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez le libelle "/>
                  <ErrorMessage name="libelle" class="text-danger"/>
                </div>
              </div>
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error , success, hideModal } from '../../utils/utils';
import { TypeCargaison } from '@/models/Tarification';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'

export default defineComponent({
    name: "AddModalTypeCargaison",
    components: {
    Form,
    Field,
    ErrorMessage,
 
  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }){
    const typeCargaisonSchema = Yup.object().shape({
      libelle: Yup.string().required('Le Libellé est obligatoire'),
      
    });

    const typeCargaisonForm = ref<TypeCargaison | null>(null);
    const addTypeCargaisonModalRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajoute une type de cargaison");
    const btntext = ref('Ajouter');
    


    watch(() => props.item, (newValue) => {
      gettypeCargaison(newValue);
      isUPDATE.value = true;
      btnTitle();
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier un type de cargaison";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter un type de cargaison";
         btntext.value = "Ajouter";
      }
    }

    const gettypeCargaison = async (id: number) => {
      return ApiService.get("/cargaison/"+id)
      .then(({ data }) => {
        const donnees = data.data;
        for (const key in donnees) {
          typeCargaisonForm.value?.setFieldValue(key, 
          (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
          );
        }
        emit('openmodal', addTypeCargaisonModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    const addTypeCargaison = async (values: any, typeCargaisonForm) => {
      values = values as TypeCargaison;
      if(isUPDATE.value){
        ApiService.put("/cargaison/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              typeCargaisonForm.resetForm();
              hideModal(addTypeCargaisonModalRef.value);
              isUPDATE.value=false;
              btnTitle();
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        ApiService.post("/cargaison",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);
              typeCargaisonForm.resetForm();
              hideModal(addTypeCargaisonModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };

    return { 
    typeCargaisonSchema,
      addTypeCargaisonModalRef,
      addTypeCargaison,
      typeCargaisonForm,
      title,btntext,resetValue,
      
    };
  },
});
</script>